<template>
    <div class="card select-none rounded-md border-0 mb-2">
        <div @click="toggle" class="card-header bg-white text-gray-700 transition duration-200 cursor-pointer rounded-t-md border border-gray-300 hover:border-gray-400 focus:border-gray-300 hover:text-gray-900 hover:bg-gray-100">
            <h3 class="text-base font-semibold mb-0">
                <i v-show="!expanded" class="fad fa-chevron-circle-right text-green-700 mr-2"></i>
                <i v-show="expanded" class="fad fa-chevron-circle-down text-green-700 mr-2"></i>
                <slot name="title" />
            </h3>
        </div>
        
        <div v-cloak v-show="expanded" class="card-body text-gray-700 text-sm rounded-b-md border border-t-0 border-gray-300">
            <slot name="body" />
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        expanded: false
    }),
    
    created() {},

    methods: {
        toggle() {
            if (this.expanded) {
                return this.collapse();
            } else {
                return this.expand();
            }
        },
        
        expand() {
            this.expanded = true;
        },
        
        collapse() {
            this.expanded = false;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
